import React from 'react';
import PropTypes from 'prop-types';
import cookie from 'react-cookies';
import { connect } from 'react-redux';
import get from 'lodash/get';
import TariffAPI from '~/src/api/tariffDetail';
import { Preloader } from '~/src/components/TariffDetail/styled';
import { Wrapper, Input, Row, Message, Note, Submit, InputPhone } from './styled';
import { getUrlParams } from '~/src/helpers/url';
import { dataLayerForCPA } from '~/src/helpers/eventsForDataLayer';
import { getClientId } from '~/src/helpers/clientInfo';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';

class Form extends React.Component {

    static propTypes = {
        city: PropTypes.object,
    };

    emptyResult = {
        status: null,
        message: null,
        billing_code: null,
    };

    constructor(props) {
        super(props);
        this.state = {
            fioIsValid: false,
            phoneIsValid: false,
            emailIsValid: true, // т.к. не required
            isSending: false,
            result: this.emptyResult,
            name: '',
            mail: '',
            phone: '',
        };
        this.fioInput = React.createRef();
        this.phoneInput = React.createRef();
        this.emailInput = React.createRef();
        this.clearPhone = undefined;
        this.isGASend = React.createRef();
    }

    checkValid = name => {
        this.setState({
            result: this.emptyResult,
        });
        setTimeout(() => {
            const hasError = get(this[`${name}Input`], 'current.state.hasError', false);
            this.setState({
                [`${name}IsValid`]: !hasError,
            });
        }, 0);
    };


    onChangePhoneHandler = data => {
        this.setState({
            phoneIsValid: data.isValid,
            phone: data.value
        });
        if (!this.clearPhone) {
            this.clearPhone = data.clearInput;
        }
    };

    formatResult = ({ billing_code, message, status }) => {
        switch (Number(billing_code)) {
            case 0: // заявка создана
            case 2:
            case 6: // дома нет в базе
                message = 'Заявка на подключение отправлена. Мы свяжемся с вами в ближайшее время.';
                break;
            case 100: // Повторная заявка
                status = 0;
                message = 'Заявка с таким номером телефона за последний час уже оставлена.';
                break;
            default:
                status = 0;
                message = 'Не удалось отправить заявку. Пожалуйста, попробуйте еще раз.1';
        }
        return {
            status,
            message,
            billing_code,
        };
    };

    setResult = result => {
        this.setState({
            result: this.formatResult(result),
        });
        TariffAPI.GA(result);
    };

    onSubmit = e => {
        const { idForm = 'request_form', isRKTariff } = this.props;
        e.preventDefault();

        const form = document.querySelector('#' + idForm);

        const requestData = new FormData(form);

        const { city, adviseEquipment, requiredEquipment, checkList } = this.props;
        const { domain, cityId } = city;

        if (requestData.get('email')) {
            dataLayerPush({
                'event': 'UAevent',
                'category': 'request page',
                'action': 'add email on request page',
                'label': undefined,
            });
        }

        const addArgsInFormData = list => {
            list.forEach(item => {
                if (item.selected) {
                    if (item.formDataArgs) {
                        // item.formDataArgs - название параметра который нужно отправить в билинг и
                        // одновременно название свойства в котором лежит значение, которое нужно отправить
                        requestData.append(item.formDataArgs, item[item.formDataArgs]);
                    }

                    if (item.tv_equipment_id) {
                        if (requestData.get('tv_equipment_id')) {
                            requestData.set('tv_equipment_id', item.tv_equipment_id);
                        } else {
                            requestData.append('tv_equipment_id', item.tv_equipment_id);
                        }

                        if (item.tv_equipment_buy) {
                            if (requestData.get('tv_equipment_buy')) {
                                requestData.set('tv_equipment_buy', item.tv_equipment_buy);
                            } else {
                                requestData.append('tv_equipment_buy', item.tv_equipment_buy);
                            }
                        }
                        if (item.tv_equipment_duration) {
                            if (requestData.get('tv_equipment_duration')) {
                                requestData.set('tv_equipment_duration', item.tv_equipment_duration);
                            } else {
                                requestData.append('tv_equipment_duration', item.tv_equipment_duration);
                            }
                        }
                    }
                    if (item.internet_equipment_id) {
                        if (requestData.get('router')) {
                            requestData.set('router', item.internet_equipment_id);
                        } else {
                            requestData.append('router', item.internet_equipment_id);
                        }
                        if (item.buy) {
                            if (requestData.get('cost_type')) {
                                requestData.set('cost_type', item.buy);
                            } else {
                                requestData.append('cost_type', item.buy);
                            }
                        }
                        if (item.duration) {
                            if (requestData.get('leasing_duration')) {
                                requestData.set('leasing_duration', item.duration);
                            } else {
                                requestData.append('leasing_duration', item.duration);
                            }
                        }
                    }
                }
            });
        };

        const getParams = getUrlParams(location);
        if (getParams.prim) {
            requestData.append('prim', getParams.prim.substr(0, 100));
        }

        if (getParams.new_rec_action) {
            requestData.append('new_rec_action', getParams.new_rec_action);
        } else if (this.props.campaign_title) {
            requestData.append('new_rec_action', this.props.promo + ',' + this.props.campaign_title);
        }

        // добавляем в FormData выбранные устройства для отправки в билинг
        addArgsInFormData(checkList.data.monthly.list);
        addArgsInFormData(checkList.data.once.list);
        if (adviseEquipment.list.length) {
            addArgsInFormData(adviseEquipment.list);
        }
        if (requiredEquipment.list.length) {
            addArgsInFormData(requiredEquipment.list);
        }

        checkList.data.monthly.list.forEach(item => {
            if (item.alias && item.alias === 'smartTv') {
                requestData.append('smart_tv$i', 1);
            }
            if (item.formData) {
                const arrayArgs = item.formData;
                arrayArgs.forEach(itemData => {
                    requestData.append(itemData.key, itemData.value);
                });
            }
        });

        checkList.data.once.list.forEach(item => {
            if (item.formData) {
                const arrayArgs = item.formData;
                arrayArgs.forEach(itemData => {
                    requestData.append(itemData.key, itemData.value);
                });
            }
        });

        const clientId = cookie.load('_ga_cid');
        requestData.append('ga_cid', clientId ? clientId : getClientId());

        requestData.append('domain', domain);
        requestData.append('city_id', cityId);

        this.setState({
            isSending: true,
        }, () => {
            TariffAPI.postData(requestData, this.props.city.domain)
                .then((data) => {
                    this.setResult({
                        status: 1,
                        ...data,
                    });

                    dataLayerForCPA(data);

                    if (isRKTariff != undefined && isRKTariff.isRKTariff) {
                        dataLayerPush({
                            event: 'UAevent',
                            category: 'application_form',
                            action: 'finished',
                            label: `body | ${city.domain} | ${window.location.pathname}`,
                        });
                        window.fbq('track', 'lead_footer');
                        window._tmr.push({ id: '3213734', type: 'reachGoal', goal: 'lead_footer' });
                    }
                })
                .catch(({ response }) => {
                    const { message, billing_code } = get(response, 'data', Object.create(null));
                    this.setResult({
                        status: 0,
                        message: message || 'Network Error',
                        billing_code,
                    });
                })
                .finally(() => {
                    if (typeof this.clearPhone == 'function') {
                        this.clearPhone();
                    }
                    this.setState({
                        isSending: false,
                        name: '',
                        mail: '',
                        phone: '',
                        fioIsValid: false,
                        phoneIsValid: false,
                    });
                });
        });
    };

    onClickFullBuy = (e) => {
        const { name, phone } = this.state;
        const { fullSaleId } = this.props;

        if (fullSaleId) {
            dataLayerPush({
                event: 'UAevent',
                category: 'fullbuy',
                action: 'click_request'
            });
            window.location = `/full-buy?fullSaleId=${fullSaleId}&name=${name}&phone=${phone}`;
        }
        e.preventDefault();
    }

    onChangeName = value => {
        const { isRKTariff, city } = this.props;
        if (!this.isGASend.current && isRKTariff != undefined && isRKTariff.isRKTariff) {
            dataLayerPush({
                event: 'UAevent',
                category: 'application_form',
                action: 'started',
                label: `body | ${city.domain} | ${window.location.pathname}`,
            });
            this.isGASend.current = true;
        }
        this.setState({ name: value }, () => this.checkValid('fio'));
    };

    onChangeEmail = value => {
        this.setState({ mail: value }, () => this.checkValid('email'));
    };

    render() {
        const { onChangeName, onChangeEmail, onChangePhoneHandler } = this;
        const { isSideBar, textBottomForm = null, selfOrder } = this.props;
        const {
            fioIsValid,
            phoneIsValid,
            emailIsValid,
            isSending,
            result,
            name,
            mail,
        } = this.state;

        const status = Number(result.status);

        return (
            <Wrapper>
                <Input
                    ref={this.fioInput}
                    onChange={onChangeName}
                    required={true}
                    type='name'
                    errorMessage='Ожидаются только буквы'
                    placeholder='Как вас зовут? *'
                    aria-label='Имя'
                    name='fio'
                    value={name}
                />
                <Row isSideBar={isSideBar}>
                    <InputPhone
                        onChange={onChangePhoneHandler}
                        errorMessage='Укажите корректный номер телефона'
                        placeholder='Номер телефона *'
                        name='phone'
                    />
                    <Input
                        ref={this.emailInput}
                        onChange={onChangeEmail}
                        type='email'
                        errorMessage='Введите корректный адрес эл.почты. Допускаются только латинские буквы, цифры, знаки _+.-'
                        placeholder='Эл. почта'
                        aria-label='E-mail'
                        name='email'
                        autoComplete='off'
                        value={mail}
                    />
                </Row>
                {Boolean(result.message) &&
                    <Message status={status}>
                        {result.message}
                    </Message>
                }
                <Row isSideBar={isSideBar}>
                    <Submit
                        onClick={this.onSubmit}
                        disabled={isSending || !(fioIsValid && phoneIsValid && emailIsValid)}
                        id='submit'
                        type='primary'
                        aria-label='Отправить'
                        text={selfOrder ? 'Заказать звонок' : 'Оставить заявку'}
                        isSideBar={isSideBar}
                        data-test='submit-request'
                    />
                    <Note
                        dangerouslySetInnerHTML={{
                            __html: `
                            Нажимая кнопку, вы даете согласие на обработку
                            <a href="https://dom.ru/policy.pdf" rel="noopener noreferrer" target="_blank">
                                персональных данных
                            </a>
                        `,
                        }}
                        isSideBar={isSideBar}
                    />
                    <Preloader waitStatus={!isSending} />
                </Row>
                { textBottomForm}
            </Wrapper>
        );

    }
}

const mapStateToProps = state => ({
    city: state.city.currentCity,
    isAuth: state.auth.isAuth,
    isRKTariff: state.villageDetail.isRKTariff
});

export default connect(mapStateToProps)(Form);
